export default "__VITE_ASSET__CuYp3AMH__"